/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Faq_4_QInputs */

const en_vc_faq_4_q = /** @type {(inputs: Vc_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which systems does VectorCraft run on?`)
};

const zh_vc_faq_4_q = /** @type {(inputs: Vc_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 支持哪些系统？`)
};

/**
* | output |
* | --- |
* | "Which systems does VectorCraft run on?" |
*
* @param {Vc_Faq_4_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_faq_4_q = /** @type {((inputs?: Vc_Faq_4_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Faq_4_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_faq_4_q(inputs)
	return zh_vc_faq_4_q(inputs)
});
export { vc_faq_4_q as "vc.faq.4.q" }